import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AddressModel } from 'src/app/models/address.model';

@Component({
  selector: 'app-address-selector',
  templateUrl: './address-selector.component.html',
  styleUrls: ['./address-selector.component.scss'],
})
export class AddressSelectorComponent implements OnInit {

  @Input() address: AddressModel;
  @Output() addressChange = new EventEmitter<AddressModel>();
  @Input() disabled = false;

  text: string;
  addresses: object[];

  constructor() { }

  ngOnInit() { }


  setAddress($event: AddressModel) {
    this.address = $event;
    this.addressChange.emit(this.address);
  }

  reset() {
    this.address = null;
  }

  manual() {
    this.address = {
      buildingName: "",
      buildingNumber: "",
      city: "",
      country: "GB",
      county: "",
      postCode: "",
      street: "",
      subBuilding: ""
    }
  }
}
